// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__B6B7E","brand":"App_brand__3x0Mp","myRepo":"App_myRepo__3UuPS"};